import Typography from "@mui/material/Typography";
import dynamic from "next/dynamic";
import styles from './productFAQs.module.css';

const ProductFAQs = (props) => {
    const { 
        faqs,
     } = props;

    return (
            <div id="faqs">
                {faqs.map((faq, idx) => {
                    return (
                        <div className={styles.faq} key={idx}>
                            <Typography className={styles.header} color="primary" component="h3" variant="h6">{faq.question}</Typography>
                            <span 
                                className={styles.answer}
                                dangerouslySetInnerHTML={{
                                    __html: faq.answer
                                }}
                            />
                        </div>
                    )
                })}
            </div>
    )
}

export default ProductFAQs